module.exports = __webpack_public_path__ + "static/product.45778177.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product.png
// module id = 967
// module chunks = 35783957827783